// import React from "react";
// import { Navigate, useRoutes } from "react-router-dom";
// import Home from "../pages/Home";
// import About from "../pages/About";
// import OurBusiness from "../pages/OurBusiness";
// import IndustriesWeServe from "../pages/IndustriesWeServe";
// import QualityCompliance from "../pages/QualityCompliance";
// import Credentials from "../pages/Credentials";
// import Contact from "../pages/Contact";
// import Notfound from "../pages/Notfound";


// // Submenu pages (You can create individual components or placeholders for these)
// import APIExcipients from "../pages/OurBusiness/SubPages/APIExcipients";
// import IndustrialChemicals from "../pages/OurBusiness/SubPages/IndustrialChemicals";
// import MetalsMinerals from "../pages/OurBusiness/SubPages/MetalsMinerals";
// import EcoPalmProducts from "../pages/OurBusiness/SubPages/EcoPalmProducts";
// import EdibleEssentialOils from "../pages/OurBusiness/SubPages/EdibleEssentialOils";
// import AgriculturalCommodities from "../pages/OurBusiness/SubPages/AgriculturalCommodities";
// import FMCG from "../pages/OurBusiness/SubPages/FMCG";
// import ProductPage from "../components/ProductPage/ProductPage";
// import FruitsAndVeg from "../pages/OurBusiness/SubPages/AgriculturalCommodities/FruitsAndVeg";
// import ProductContentCard from "../components/ProductContentCard/ProductContentCard";
// import Spices from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Spices/Spices";
// import Rice from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Rice/Rice";
// import Chickpeas from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Chickpeas/Chickpeas";
// import Nuts from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Nuts/Nuts";
// import Cashews from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Cashews";
// import Peanuts from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Peanuts";
// import Polypropylene from "../pages/OurBusiness/SubPages/Polypropylene/polypropylene";
// // import Mobility from "../pages/OurBusiness/SubPages/Polypropylene/Mobility";
// // import Healthcare from "../pages/OurBusiness/SubPages/Polypropylene/Healthcare";
// // import Packaging from "../pages/OurBusiness/SubPages/Polypropylene/Packaging";
// // import Agricultural from "../pages/OurBusiness/SubPages/Polypropylene/Agricultural";
// import {
//   Mobility,
//   BuildingConstruction,
//   Consumer,
//   ElectricalElectronics
// } from "../pages/OurBusiness/SubPages/Polypropylene";


// export default function DohrniiRoutes() {
//   const ROUTES = [
//     {
//       path: "",
//       element: <Home />,
//     },
//     {
//       path: "about",
//       element: <About />,
//     },
//     {
//       path: "business",
//       element: <OurBusiness />,
//     },

//     // Submenu Routes for "Our Business"
//     {
//       path: "business/polypropylene",
//       element: <Polypropylene />,
//     },

//     {
//       path: "business/polypropylene/mobility",
//       element: <Mobility />,
//     },
//     {
//       path: "business/polypropylene/building-construction",
//       element: <BuildingConstruction />,
//     },
//     {
//       path: "business/polypropylene/consumer",
//       element: <Consumer />,
//     },
//     {
//       path: "business/polypropylene/electrical-electronics",
//       element: <ElectricalElectronics />,
//     },



//     {
//       path: "business/api-excipients",
//       element: <APIExcipients />,
//     },
//     {
//       path: "business/api-excipients/:productName",
//       element: <ProductContentCard />,
//     },
//     {
//       path: "business/industrial-chemicals",
//       element: <IndustrialChemicals />,
//     },
//     {
//       path: "business/metals-minerals",
//       element: <MetalsMinerals />,
//     },
//     {
//       path: "business/ecopalm-products",
//       element: <EcoPalmProducts />,
//     },
//     {
//       path: "business/ecopalm-products/:productId",
//       element: <ProductPage />,
//     },
//     {
//       path: "business/edible-essential-oils",
//       element: <EdibleEssentialOils />,
//     },
//     {
//       path: "business/agricultural-commodities",
//       element: <AgriculturalCommodities />,
//     },
//     {
//       path: "business/agricultural-commodities/FruitsAndVeg",
//       element: <FruitsAndVeg />,
//     },
//     {
//       path: "business/agricultural-commodities/spices",
//       element: <Spices />,
//     },
//     {
//       path: "business/agricultural-commodities/rice",
//       element: <Rice />,
//     },
//     {
//       path: "business/agricultural-commodities/chickpeas",
//       element: <Chickpeas />,
//     },
//     {
//       path: "business/agricultural-commodities/cashews",
//       element: <Cashews />,
//     },
//     {
//       path: "business/agricultural-commodities/peanuts",
//       element: <Peanuts />,
//     },
//     {
//       path: "business/agricultural-commodities/nuts",
//       element: <Nuts />,
//     },
//     {
//       path: "business/fmcg",
//       element: <FMCG />,
//     },
//     // Normal Route Starts

//     // {
//     //   path: "industries-we-serve",
//     //   element: <IndustriesWeServe />,
//     // },
//     {
//       path: "quality-compliance",
//       element: <QualityCompliance />,
//     },
//     {
//       path: "credentials",
//       element: <Credentials />,
//     },
//     {
//       path: "contact",
//       element: <Contact />,
//     },
//     {
//       path: "not-found",
//       element: <Notfound />,
//     },
//     // Default Route
//     {
//       path: "*",
//       element: <Navigate to="/" replace={true} />,
//     },
//   ];

//   let routes = useRoutes(ROUTES);
//   return routes;
// }


import { Navigate, useRoutes } from "react-router-dom";

// ==== Main Pages ====
import Home from "../pages/Home";
import About from "../pages/About";
import OurBusiness from "../pages/OurBusiness";
// import QualityCompliance from "../pages/QualityCompliance";
import Credentials from "../pages/Credentials";
import Contact from "../pages/Contact";
import Notfound from "../pages/Notfound";

// ==== Our Business Sub Pages ====
import Automobiles from "../pages/OurBusiness/SubPages/Automobiles";
// import automobiles from "../../../../data/automobileData";
import CarDetails from "../pages/OurBusiness/SubPages/CarDetails/CarDetails";
import APIExcipients from "../pages/OurBusiness/SubPages/APIExcipients";
import Tyre from "../pages/OurBusiness/SubPages/Tyre";
import IndustrialChemicals from "../pages/OurBusiness/SubPages/IndustrialChemicals";
import MetalsMinerals from "../pages/OurBusiness/SubPages/MetalsMinerals";
import EcoPalmProducts from "../pages/OurBusiness/SubPages/EcoPalmProducts";
import EdibleEssentialOils from "../pages/OurBusiness/SubPages/EdibleEssentialOils";
import AgriculturalCommodities from "../pages/OurBusiness/SubPages/AgriculturalCommodities";
import FMCG from "../pages/OurBusiness/SubPages/FMCG";

// ==== Components ====
import ProductPage from "../components/ProductPage/ProductPage";
import ProductContentCard from "../components/ProductContentCard/ProductContentCard";

// ==== Agricultural Subpages ====
import FruitsAndVeg from "../pages/OurBusiness/SubPages/AgriculturalCommodities/FruitsAndVeg";
import Vegetables from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Vegetables/Vegetables";
import Spices from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Spices/Spices";
import Rice from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Rice/Rice";
import Chickpeas from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Chickpeas/Chickpeas";
import Nuts from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Nuts/Nuts";
import Cashews from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Cashews";
import Peanuts from "../pages/OurBusiness/SubPages/AgriculturalCommodities/Peanuts";


// ==== Agricultural DryFruits-Nuts Subpages ====
import Almond from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Almond";
import Apricots from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Apricots";
import Berries from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Berries";
import Cashew from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Cashew";
import Dates from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Dates";
import Figs from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Figs";
import IndianTraditionalProducts from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/IndianTraditionalProducts";
import Pistachios from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Pistachios";
import PremiumNuts from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/PremiumNuts";
import Raisins from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Raisins";
import Seeds from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Seeds";
import Walnuts from "../pages/OurBusiness/SubPages/AgriculturalCommodities/DryFruits-Nuts/Walnuts";



// ==== Polypropylene Pages ====

import Polypropylene from "../pages/OurBusiness/SubPages/Polypropylene";
import PcrTyres from "../pages/OurBusiness/SubPages/Tyre/PcrTyres";
import TbrTyres from "../pages/OurBusiness/SubPages/Tyre/TbrTyres";
import OtrTyres from "../pages/OurBusiness/SubPages/Tyre/OtrTyres";
import Construction from "../pages/OurBusiness/SubPages/Construction";

export default function DohrniiRoutes() {
  const ROUTES = [
    { path: "/", element: <Home /> },
    { path: "about", element: <About /> },
    { path: "business", element: <OurBusiness /> },

    // === Polypropylene and Subpages ===
    // { path: "business/automobiles", element: <Automobiles /> },


    // === Automobiles ===
    // Automobiles
    { path: "business/automobiles", element: <Automobiles /> },
    { path: "business/automobiles/:slug", element: <CarDetails /> },

    { path: "business/Polypropylene", element: <Polypropylene /> },
    { path: "business/Tyre", element: <Tyre /> },
    { path: "business/pcr-tyres", element: <PcrTyres /> },
    { path: "business/tbr-tyres", element: <TbrTyres /> },
    { path: "business/otr-tyres", element: <OtrTyres /> },
    { path: "business/Construction", element: <Construction /> },


    // ==== Agricultural DryFruits-Nuts Subpages ====
    { path: "business/agricultural-commodities/DryFruits-Nuts/Almond", element: <Almond /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Apricots", element: <Apricots /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Berries", element: <Berries /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Cashew", element: <Cashew /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Dates", element: <Dates /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Figs", element: <Figs /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/IndianTraditionalProducts", element: <IndianTraditionalProducts /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Pistachios", element: <Pistachios /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/PremiumNuts", element: <PremiumNuts /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Raisins", element: <Raisins /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Seeds", element: <Seeds /> },
    { path: "business/agricultural-commodities/DryFruits-Nuts/Walnuts", element: <Walnuts /> },




    // === Other Businesses ===
    { path: "business/api-excipients", element: <APIExcipients /> },
    { path: "business/api-excipients/:productName", element: <ProductContentCard /> },
    { path: "business/industrial-chemicals", element: <IndustrialChemicals /> },
    { path: "business/metals-minerals", element: <MetalsMinerals /> },
    { path: "business/ecopalm-products", element: <EcoPalmProducts /> },
    { path: "business/ecopalm-products/:productId", element: <ProductPage /> },
    { path: "business/edible-essential-oils", element: <EdibleEssentialOils /> },
    { path: "business/agricultural-commodities", element: <AgriculturalCommodities /> },
    { path: "business/agricultural-commodities/FruitsAndVeg", element: <FruitsAndVeg /> },
    { path: "business/agricultural-commodities/spices", element: <Spices /> },
    { path: "business/agricultural-commodities/Vegetables", element: <Vegetables /> },
    { path: "business/agricultural-commodities/rice", element: <Rice /> },
    { path: "business/agricultural-commodities/chickpeas", element: <Chickpeas /> },
    { path: "business/agricultural-commodities/cashews", element: <Cashews /> },
    { path: "business/agricultural-commodities/peanuts", element: <Peanuts /> },
    { path: "business/agricultural-commodities/nuts", element: <Nuts /> },
    { path: "business/fmcg", element: <FMCG /> },

    // === General Pages ===
    // { path: "quality-compliance", element: <QualityCompliance /> },
    { path: "credentials", element: <Credentials /> },
    { path: "contact", element: <Contact /> },
    { path: "not-found", element: <Notfound /> },
    { path: "*", element: <Navigate to="/" replace /> },
  ];

  return useRoutes(ROUTES);
}
